import React, { useRef, useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import './Reviews.css';

const reviews = [
  {
    id: 1,
    name: "Priya Ranganathan",
    role: "Founder, TechSolutions Pvt Ltd",
    country: "India",
    rating: 5,
    service: "GST Filing & Compliance",
    content:
      "Krinvy has been managing our GST filings since the last two years. Their team is prompt, accurate, and always up to date on the latest compliance requirements. Highly recommend!",
    avatar: "P"
  },
  {
    id: 2,
    name: "Michael Thompson",
    role: "CEO, InnovateTech Inc.",
    country: "USA",
    rating: 5,
    service: "Payroll Services",
    content:
      "We've outsourced our payroll processing to Krinvy, and it’s been seamless. No errors, timely delivery, and great support during tax season. The team goes above and beyond.",
    avatar: "M"
  },
  {
    id: 3,
    name: "Anjali Deshmukh",
    role: "HR Manager, FinCorp India",
    country: "India",
    rating: 4,
    service: "Payroll Processing (India)",
    content:
      "Their payroll services have saved us hours of manual work. They handle PF, ESI, PT, and salary slips efficiently. Just need a little faster turnaround at times.",
    avatar: "A"
  },
  {
    id: 4,
    name: "Sarah Mitchell",
    role: "Marketing Director, Bloom Digital",
    country: "USA",
    rating: 5,
    service: "Web Development",
    content:
      "The website they built for us is stunning—fully responsive and optimized for performance. We’ve seen a 40% increase in user engagement since launch. Amazing work!",
    avatar: "S"
  },
  {
    id: 5,
    name: "Rajiv Mehta",
    role: "CTO, CloudOps India",
    country: "India",
    rating: 5,
    service: "Business Registration",
    content:
      "They handled our entire company registration process from start to finish. Got our PAN, TAN, and all legal documents in record time. Will definitely use them again.",
    avatar: "R"
  },
  {
    id: 6,
    name: "David Kim",
    role: "Operations Lead, US Logistics Co.",
    country: "USA",
    rating: 5,
    service: "IT Solutions",
    content:
      "Our legacy systems were outdated and inefficient until Krinvy stepped in. They modernized everything, integrated our CRM, and now we're running like clockwork.",
    avatar: "D"
  },
  {
    id: 7,
    name: "Neha Shah",
    role: "Owner, Shah Designs",
    country: "India",
    rating: 5,
    service: "Graphic Design",
    content:
      "I’m so impressed by their creative team! They designed my logo, business cards, and website banners exactly how I envisioned. Professional, fast, and affordable.",
    avatar: "N"
  },
  {
    id: 8,
    name: "Emily Foster",
    role: "E-commerce Manager",
    country: "USA",
    rating: 5,
    service: "AI Chatbot Automation",
    content:
      "Since integrating their chatbots into WhatsApp and Instagram, our cart abandonment dropped by 25%. Customer engagement has never been better!",
    avatar: "E"
  }
];

const Reviews = () => {
  const trackRef = useRef(null);
  const animationRef = useRef();
  const progressRef = useRef(0);

  const animate = () => {
    progressRef.current += 0.2; // Adjust this value to change speed (smaller = slower)
    
    // Reset when we've scrolled one full set of reviews
    if (progressRef.current >= 100) {
      progressRef.current = 0;
    }
    
    if (trackRef.current) {
      trackRef.current.style.transform = `translateX(-${progressRef.current}%)`;
    }
    
    animationRef.current = requestAnimationFrame(animate);
  };

  const handleHoverStart = () => {
    cancelAnimationFrame(animationRef.current);
  };

  const handleHoverEnd = () => {
    animationRef.current = requestAnimationFrame(animate);
  };

  useEffect(() => {
    animationRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationRef.current);
  }, []);

  return (
    <section className="kr-reviews-section">
      <div className="kr-reviews-container">
        <h2 className="kr-reviews-title">What Our Clients Say</h2>
        <p className="kr-reviews-subtitle">
          Trusted by businesses across India and the U.S., Krinvy delivers excellence in software solutions, digital transformation and more.
        </p>

    <div className="kr-reviews-scroll-wrapper">
  <div className="kr-reviews-track-loop">
    {[...reviews, ...reviews].map((review, index) => (
      <div className="kr-review-card" key={`${review.id}-${index}`}>
        <div className="kr-review-header">
          <div className="kr-review-avatar">{review.avatar}</div>
          <div className="kr-review-user">
            <h4 className="kr-review-name">{review.name}</h4>
            <p className="kr-review-role">{review.role}, {review.country}</p>
          </div>
        </div>
        <div className="kr-review-service"><span>{review.service}</span></div>
        <div className="kr-review-rating">
          {"★".repeat(review.rating)}{"☆".repeat(5 - review.rating)}
        </div>
        <p className="kr-review-text">{review.content}</p>
      </div>
    ))}
  </div>
</div>

      </div>
    </section>
  );
};

export default Reviews;